import React from 'react';
import Auxiliary from '../../util/Auxiliary';

const NotFound = (props) => {
  return (
    <Auxiliary>
      <h1>Halaman Tidak Ditemukan</h1>
    </Auxiliary>
  );
}

export default NotFound;